<template>
  <v-row>
    <v-col cols="12">
      <v-card min-width="320" to="/setActiveService">
        <v-card-title>
          {{ activeService.id ? "Change" : "Set" }} Active Service
        </v-card-title>
      </v-card>
    </v-col>

    <v-col cols="12" v-if="activeService.id">
      <v-card min-width="320" to="/addSample">
        <v-card-title>Add X-ray Sample</v-card-title>
      </v-card>
    </v-col>

    <v-col cols="12" v-if="activeService.id">
      <v-card min-width="320" to="/viewSubmissions">
        <v-card-title>View X-ray Submissions</v-card-title>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { GetActiveOffsiteService } from "@/store/offsiteService";
import { GetDate } from "@/common/utilities/date";

export default {
  name: "MenuItems",

  mounted() {
    this.activeService = GetActiveOffsiteService();
  },

  data: () => ({
    activeService: { id: null, name: null, schedule: null }
  }),

  computed: {
    isActiveServiceToday() {
      if (this.activeService.id) {
        return GetDate(this.activeService.schedule) === GetDate(new Date());
      }

      return false;
    }
  }
};
</script>
